import React from 'react'
import type { IconDefaultProps } from '../../../models/types'

const LanguageIcon = ({ className, color }: IconDefaultProps): JSX.Element => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 17.578 17.581'
      className={className || 'rf-w-4 rf-h-4'}
    >
      <g transform='translate(0)'>
        <path
          d='M16.861,8.789V2.572A2.072,2.072,0,0,0,14.789.5H8.572A2.072,2.072,0,0,0,6.5,2.572V8.789a2.072,2.072,0,0,0,2.072,2.072h6.217A2.072,2.072,0,0,0,16.861,8.789Z'
          transform='translate(0.217)'
          fill='none'
          stroke={color || '#FFF'}
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1'
          fillRule='evenodd'
        />
        <path
          d='M4.645,6.5H2.572A2.072,2.072,0,0,0,.5,8.576v6.216a2.072,2.072,0,0,0,2.072,2.072h0l6.217-.011a2.072,2.072,0,0,0,2.069-2.072V12.717'
          transform='translate(0 0.217)'
          fill='none'
          stroke={color || '#FFF'}
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1'
          fillRule='evenodd'
        />
        <g transform='translate(2.572 10.864)'>
          <path
            d='M3.106,1H0'
            transform='translate(0.002 -1.003)'
            fill='none'
            stroke={color || '#FFF'}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1'
            fillRule='evenodd'
          />
          <path
            d='M4.625,2.5,3.589,3.536A11.99,11.99,0,0,1,1,5.09'
            transform='translate(0.038 -0.949)'
            fill='none'
            stroke={color || '#FFF'}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1'
            fillRule='evenodd'
          />
          <path
            d='M1,1A4.739,4.739,0,0,0,2.553,3.592a17.063,17.063,0,0,0,2.59,1.553'
            transform='translate(0.038 -1.003)'
            fill='none'
            stroke={color || '#FFF'}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1'
            fillRule='evenodd'
          />
        </g>
        <g transform='translate(8.789 2.572)'>
          <path
            d='M3.108,0,0,6.217'
            fill='none'
            stroke={color || '#FFF'}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1'
            fillRule='evenodd'
          />
          <path
            d='M3,0,6.108,6.217'
            transform='translate(0.108)'
            fill='none'
            stroke={color || '#FFF'}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1'
            fillRule='evenodd'
          />
          <path
            d='M0,0V4.145'
            transform='translate(5.181 4.145) rotate(90)'
            fill='none'
            stroke={color || '#FFF'}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1'
            fillRule='evenodd'
          />
        </g>
      </g>
    </svg>
  )
}

export default LanguageIcon
